export type InertialVisibilityUiState = {
  focus: boolean;
  orientationAxes: boolean;
};

export const INERTIAL_VISIBILITY_UI_EVENT = "selected-inertial-visibility-options-changed";

export const DEFAULT_INERTIAL_VISIBILITY_UI_STATE: InertialVisibilityUiState = {
  focus: false,
  orientationAxes: false,
};

export function dispatchInertialVisibilityUiState(state: InertialVisibilityUiState): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(INERTIAL_VISIBILITY_UI_EVENT, {
      detail: { ...state },
    })
  );
}
